<template>
    <defs>
      <pattern id="diagonalDots" patternUnits="userSpaceOnUse" width="60" height="60">
        <rect width="60" height="60" fill="#A86B5A" />
        <circle cx="10" cy="10" r="6" fill="#6E2F1F" opacity="0.9"/>
        <circle cx="30" cy="10" r="6" fill="#6E2F1F" opacity="0.9"/>
        <circle cx="50" cy="10" r="6" fill="#6E2F1F" opacity="0.9"/>
        <circle cx="10" cy="30" r="6" fill="#6E2F1F" opacity="0.9"/>
        <circle cx="30" cy="30" r="6" fill="#6E2F1F" opacity="0.9"/>
        <circle cx="50" cy="30" r="6" fill="#6E2F1F" opacity="0.9"/>
        <circle cx="10" cy="50" r="6" fill="#6E2F1F" opacity="0.9"/>
        <circle cx="30" cy="50" r="6" fill="#6E2F1F" opacity="0.9"/>
        <circle cx="50" cy="50" r="6" fill="#6E2F1F" opacity="0.9"/>
      </pattern>
    </defs>
</template>
